export enum VoucherHolderAction {
    Unknown = 9,
    Edit = 1,
    OrderBuccalSwabKit = 2,
    OrderLabScreening = 3,
    StartRedemption = 4,
    UploadVoucherConsent = 5,
    UploadSwabResults = 6,
    UploadScreeningResults = 7,
    ReorderLabScreening = 8,
    ResendLink = 9
}